import { PromptTemplate, GrowthStrategy } from '../types';

export const promptTemplate: PromptTemplate = {
  role: '在这里，定义你想要AI扮演的角色。把它想象成你要免费聘请的"专家"。',
  goal: '你想要这个角色帮你达成的最终目标是什么？目标是我们所有任务的北极星。',
  task: '你想让这个角色帮你解决的问题是什么？把大目标分解成AI可以执行的"行动清单"。',
  example: '如果你的任务是有理想的回答参考的，你就把案例放到提示词中，这样有助于AI更加理解你的目标。',
  output: '你想让AI输出的是什么和如何输出？是Markdown格式，是要幽默风趣、专业严谨，还是要求在1000字以内？'
};

export const examplePrompt = `你现在是一位经验丰富的大学社团活动策划师。请帮我们【吉他社】策划一场迎新派对，具体要求如下：

背景：我们是一个氛围轻松、主打民谣弹唱的社团。

目标：让大约30名新老成员快速破冰，感受到社团的温暖和有趣，最好能创造机会让他们一起弹唱。

条件：
预算：500元以内。
时间：下周五晚上7-9点。
地点：学校的公共活动室（有插座和投影仪）。

任务：
请为活动起一个温馨且符合民谣主题的名字。
设计一个完整的活动流程，要包含2-3个和音乐或吉他相关的互动游戏。
列出一份详细的物料采购清单和预算分配。
最后，请用一个轻松、吸引人的口吻，帮我写一段发在社团群里的宣传文案。

请用清晰的、带序号的列表形式输出所有内容。`;

export const growthStrategies: GrowthStrategy[] = [
  {
    id: 'public-learning',
    title: '公开学习，建立影响力',
    description: '把自己学习、探索、甚至犯错的过程，变成有价值的分享，发布在公共的媒体平台。',
    steps: [
      '选择一个你感兴趣的AI+专业领域组合',
      '从最轻量级的输出开始：一张截图+几句心得',
      '记录真实的学习过程和遇到的问题',
      '分享解决方案和心得体会',
      '与同样在探索AI的同学建立联系'
    ],
    benefits: [
      '倒逼自己学习更透彻',
      '吸引同样在探索AI的同学和牛人',
      '建立个人品牌和影响力',
      '获得潜在的合作机会',
      '成为"被看见"的持续成长者'
    ]
  },
  {
    id: 'ai-plus-major',
    title: 'AI + 专业课深度结合',
    description: '从你最头疼的那门专业课开始，公开记录你如何用AI帮你读论文、理解复杂概念、做复习资料的全过程。',
    steps: [
      '选择一门你觉得有挑战的专业课',
      '尝试用AI工具辅助学习',
      '记录使用过程中的发现和技巧',
      '分享AI在该专业领域的应用心得',
      '建立该领域的AI应用知识库'
    ],
    benefits: [
      '提高专业课学习效率',
      '成为专业+AI结合的先行者',
      '为同专业同学提供价值',
      '建立专业领域的差异化优势'
    ]
  },
  {
    id: 'ai-plus-hobby',
    title: 'AI + 兴趣爱好创新探索',
    description: '结合你的兴趣爱好，探索AI在该领域的创新应用，分享你的探索过程和成果。',
    steps: [
      '确定你最感兴趣的爱好领域',
      '研究AI在该领域的应用可能性',
      '动手实践和实验',
      '记录实验过程和结果',
      '分享创新的应用方法'
    ],
    benefits: [
      '让兴趣爱好更有深度',
      '发现新的创作可能性',
      '在兴趣圈子中建立影响力',
      '可能发现商业机会'
    ]
  }
];